import React from "react";

const AboutVideoModal = () => (
    <iframe
        src="https://player.vimeo.com/video/48846655?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1"
        width="900"
        height="506"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
    />
);

export default AboutVideoModal;
